var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDefaultProps } from '../../helpers/builders';
export var builderTagProps = function (_a) {
    var variant = _a.variant, theme = _a.theme;
    var defaultStyles = {
        height: theme.fixedHeight.sm,
        bRadius: 'xs',
        labelTypographyProps: {
            type: 'p2',
            fontWeight: 'medium',
        },
    };
    var tag = {
        primary: __assign({ bgColor: theme.brand.color.primary.pure, bWidth: 'none', bStyle: 'none', bColor: 'transparent', labelColor: theme.neutrals.pureWhite }, defaultStyles),
        secondary: __assign({ bgColor: theme.neutrals.gray2, bWidth: 'none', bStyle: 'none', bColor: 'transparent', labelColor: theme.neutrals.gray5 }, defaultStyles),
        tertiary: __assign({ bgColor: 'transparent', bWidth: 'hairline', bStyle: 'solid', bColor: theme.neutrals.gray5, labelColor: theme.neutrals.gray5 }, defaultStyles),
    };
    return tag[variant || 'primary'];
};
var customTagProps = function (props) {
    var tagProps = builderTagProps(props);
    return buildDefaultProps(__assign(__assign({}, props), { bColor: props.variant === 'tertiary'
            ? (props === null || props === void 0 ? void 0 : props.labelColor) || (props === null || props === void 0 ? void 0 : props.bColor)
            : props === null || props === void 0 ? void 0 : props.bColor }), tagProps);
};
export { customTagProps };
